import { Token } from '@/resources/Token';
import { AppCollection } from '@/stores/AppStore';

export const getToken = async (
  store: AppCollection,
  userId: string,
  resourceId: string,
  resourceType: string,
  chatType = 'question'
) => {
  // `${chatType}-${userId}-${resourceType}-${resourceId}`;
  const lid = Token.generateLid({
    chatType,
    userId,
    resourceType,
    resourceId,
  });

  const tokenResponse = await store.request<Token>(`tokens/${lid}`, 'GET', null, {
    headers: {
      accept: 'application/vnd.api+json',
      'content-type': 'application/vnd.api+json',
    },
  });

  return tokenResponse;
};
